import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { ProcessesStatus } from '../models/Chart';

export default class ChartApi {

    private http: HTTPClient;
    private rootPath: string;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
    }

    public async getProcessesStatus(pkCuaa: number, campaign: number): Promise<ProcessesStatus[]> {
        const res = await this.http.get(`${this.rootPath}/dashboard/scs/${pkCuaa}/campaigns/${campaign}/processes`);
        return res.data;
    }
}
